const DescriptionItem = ({text, isLast }) => {
    return (
      <div>
        <p className="description-line">{text}</p>
        <hr className={isLast ? "" : "dotted"} />
      </div>
    );
  };
  
  export default DescriptionItem;